import { dispatchEvent } from 'redux-ruleset'

export const buttonClick = () =>
  dispatchEvent({
    type: 'CartSummary/PaypalExpress/BUTTON_CLICK' as const
  })

export const paymentApproved = () =>
  dispatchEvent({
    type: 'CartSummary/PaypalExpress/PAYMENT_APPROVED' as const
  })

export type Event =
  | ReturnType<typeof buttonClick>
  | ReturnType<typeof paymentApproved>

declare global {
  interface RulesetDispatchEvents {
    'CartSummary/PaypalExpress': Event
  }
}
